'use client'

import { useEffect, useState } from "react"
import Button from "../button/Button"
import FacebookSDK from "./FacebookSDK"
import { ICONS } from "./Icons"
import useEventListener, { emitEvent } from "./EventListener"


export default function GoogleLoginPlugin(props) {

  const {site} = props
  
  const [ctx, setCtx] = useState()
  const [googleButton, setGoogleButton] = useState()

  useEventListener("launch_google_login", event => {
    setCtx(event.detail.ctx)
    login()
  })

  useEventListener("google_login_complete", event => {
    emitEvent("third_party_signin", Object.assign(event.detail, { ctx: ctx }))
  })

  useEffect(() => {
    if (site.api_keys?.g_oauth_client_id) {
      setTimeout(() => {
        window.google?.accounts?.id?.initialize({
          client_id: site.api_keys.g_oauth_client_id,
          ux_mode: "",
          callback: googleLoginCallback,
        });
        window.google?.accounts?.id?.prompt();
        const b = createFakeGoogleWrapper()
        setGoogleButton(b)
      }, 500)
    }
  }, [])

  const createFakeGoogleWrapper = () => {
    const googleLoginWrapper = document.createElement("div");
    // Or you can simple hide it in CSS rule for custom-google-button
    googleLoginWrapper.style.display = "none";
    googleLoginWrapper.classList.add("custom-google-button");

    // Add the wrapper to body
    document.body.appendChild(googleLoginWrapper);

    // Use GSI javascript api to render the button inside our wrapper
    // You can ignore the properties because this button will not appear
    window.google?.accounts?.id?.renderButton(googleLoginWrapper, {
      type: "icon",
      width: "200",
    });

    const googleLoginWrapperButton =
      googleLoginWrapper.querySelector("div[role=button]");

    return {
      click: () => {
        googleLoginWrapperButton.click();
      },
    };
  };

  const login = () => {
    googleButton.click();
  }

  const googleLoginCallback = (response) => {
    const responsePayload = JSON.parse(Buffer.from(response.credential.split('.')[1], 'base64').toString());
    emitEvent("google_login_complete", {
      ctx: ctx,
      platform: 'google',
      src: 'login_form',
      account_id: responsePayload.sub,
      email: responsePayload.email,
      first_name: responsePayload.given_name,
      last_name: responsePayload.family_name,
      photo: responsePayload.picture,
      access_token: response.credential,
    })
  }  
  
  return <></>
   
}